import React, { useState } from "react";
import "./merchant-details.scss";
import { Link } from "react-router-dom";
import MerchantListings from "./MerchantListings";
import DealsMenagement from "../../DealsManagement/DealsSection/DealsSection"
import { updateMerchant } from "../../../../requests/merchantApi";
import moment from "moment";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const MerchantDetailSection = ({ data }) => {
  const navigate = useNavigate()

const handleUpdateMerchant = async (merchant) => {
  const data = await updateMerchant(merchant._id, { approvalStatus: merchant.approvalStatus !== "approved" ? "approved" : "blocked"})
  if(data.status) {
    toast.success("Merchant has been updated")
    navigate("/merchant-management")
  } else {
    toast.error(data.message)
  }
}

  return (
    <>
      <div className="merchant-detail-wrap">
        <div className="merchant-detail-wrapper">
          {/* Bootstrap Nav Tabs */}
          <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between merchant-detail-header">
            <ul
              className="nav nav-tabs merchant-detail"
              id="myTab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="merchantDetail-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#merchantDetail"
                  type="button"
                  role="tab"
                  aria-controls="merchantDetail"
                  aria-selected="false"
                >
                  Merchant Review
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="listingReview-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#listingReview"
                  type="button"
                  role="tab"
                  aria-controls="listingReview"
                  aria-selected="true"
                >
                  Listing Review
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="dealReview-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#dealReview"
                  type="button"
                  role="tab"
                  aria-controls="dealReview"
                  aria-selected="true"
                >
                  Deal Review
                </button>
              </li>
            </ul>
          </div>

          {/* Tab Content */}
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="merchantDetail"
              role="tabpanel"
              aria-labelledby="merchantDetail-tab"
            >
              <div className="details-wrap">
                <h2>Merchant Detail</h2>
                <div className="row">
                  <div className="col-xl-3 col-md-6 p-2">
                    <div className="kyc-box">
                      <span>Merchant Name</span>
                      <p>{data.fullName}</p>
                    </div>
                  </div>
                  <div className="col-xl-3 col-md-6 p-2">
                    <div className="kyc-box">
                      <span>Status</span>
                      <p>{data.approvalStatus}</p>
                    </div>
                  </div>
                  <div className="col-xl-3 col-md-6 p-2">
                    <div className="kyc-box">
                      <span>Created on</span>
                      <p>{moment(data.created_at).format("YYYY-MM-DD")}</p>
                    </div>
                  </div>
                  <div className="col-xl-3 col-md-6 p-2">
                    <div className="kyc-box">
                      <span>Last Active</span>
                      <p>08 July, 2025</p>
                    </div>
                  </div>
                </div>
                <div className="merchant-status-wrap">
                  <div className="content">
                    <h6>Merchant Status</h6>
                    <p>
                      This merchant is currently active and can submit listings
                      and receive payouts.
                    </p>
                  </div>
                  <label className="toggle-switch">
                    <input type="checkbox" checked={data.approvalStatus === "approved"} onChange={() => handleUpdateMerchant(data)}/>
                    <span className="slider"></span>
                  </label>
                </div>
              </div>
              {/* <div className="merchant-detail-wraps">
                <h2>KYC Documents</h2>
                <div className="row">
                  <div className="col-xl-3 col-md-6 p-2">
                    <div className="kyc-box">
                      <span>Sumsub ID</span>
                      <p>sumsub_ae9384djsd</p>
                    </div>
                  </div>
                  <div className="col-xl-3 col-md-6 p-2">
                    <div className="kyc-box">
                      <span>Verification Status</span>
                      <p>Verified</p>
                    </div>
                  </div>
                  <div className="col-xl-3 col-md-6 p-2">
                    <div className="kyc-box">
                      <span>Created on</span>
                      <p>08 July, 2025</p>
                    </div>
                  </div>
                  <div className="col-xl-3 col-md-6 p-2">
                    <div className="kyc-box">
                      <span>Last Active</span>
                      <p>08 July, 2025</p>
                    </div>
                  </div>
                </div>
                <div className="doc-title-wrap">
                  <h3>Document Links</h3>
                  <Link to="">
                    <img src="/images/icons/golden-eye.svg" alt="view" />
                    Re-Request Docs
                  </Link>
                </div>
                <div className="documents-wrap">
                  <div className="doc-item">
                    <div className="name">
                      <div className="icon">
                        <img src="/images/icons/doc-icon.svg" alt="doc" />
                      </div>
                      <h4>ID Card Front/Back</h4>
                    </div>
                    <Link>
                      <img src="/images/icons/white-eye.svg" alt="view" /> View
                    </Link>
                  </div>
                  <div className="doc-item">
                    <div className="name">
                      <div className="icon">
                        <img src="/images/icons/doc-icon.svg" alt="doc" />
                      </div>
                      <h4>Proof of Address</h4>
                    </div>
                    <Link>
                      <img src="/images/icons/white-eye.svg" alt="view" /> View
                    </Link>
                  </div>
                  <div className="doc-item">
                    <div className="name">
                      <div className="icon">
                        <img src="/images/icons/doc-icon.svg" alt="doc" />
                      </div>
                      <h4>Company Certificate (if corporate)</h4>
                    </div>
                    <Link>
                      <img
                        src="/images/icons/download-icon.svg"
                        alt="download"
                      />{" "}
                      Download
                    </Link>
                  </div>
                </div>
              </div> */}
              <div className="merchant-detail-wraps">
                <h2>Bank Details</h2>
                <div className="bank-cards-wrap">
                  <div className="kyc-box">
                    <span>Wise Recipient ID</span>
                    <p>{data.recipientId}</p>
                  </div>
                  <div className="kyc-box">
                    <span>Bank Name</span>
                    <p>{data.bankDetails?.bankCode}</p>
                  </div>
                  <div className="kyc-box">
                    <span>Account Holder Name</span>
                    <p>{data.fullName}</p>
                  </div>
                  <div className="kyc-box">
                    <span>Currency</span>
                    <p>{data.bankDetails?.currency}</p>
                  </div>
                  {/* <div className="kyc-box">
                    <span>Linked category</span>
                    <p>sumsub_ae9384djsd</p>
                  </div> */}
                </div>
              </div>
              <div className="merchant-detail-wraps">
                <h2>Earnings Summary</h2>
                <div className="row">
                  <div className="col-xl-3 col-md-6 p-2">
                    <div className="kyc-box">
                      <span>Total Earnings</span>
                      <p>sumsub_ae9384djsd</p>
                    </div>
                  </div>
                  <div className="col-xl-3 col-md-6 p-2">
                    <div className="kyc-box">
                      <span>Last Payout</span>
                      <p>Verified</p>
                    </div>
                  </div>
                  <div className="col-xl-3 col-md-6 p-2">
                    <div className="kyc-box">
                      <span>Payout Frequency</span>
                      <p>08 July, 2025</p>
                    </div>
                  </div>
                  <div className="col-xl-3 col-md-6 p-2">
                    <div className="kyc-box">
                      <span>Payout Frequency</span>
                      <p>08 July, 2025</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="listingReview"
              role="tabpanel"
              aria-labelledby="listingReview-tab"
            >
              <MerchantListings merchant={data._id}/>
            </div>
            <div
              className="tab-pane fade"
              id="dealReview"
              role="tabpanel"
              aria-labelledby="dealReview-tab"
            >
              <DealsMenagement merchant={data._id}/>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MerchantDetailSection;
